module.exports = __webpack_public_path__ + "img/search.26801c1a.png";